import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCheck = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 11,
	viewBox: "0 0 16 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14.7812 0.496094C15.0625 0.808594 15.0625 1.27734 14.7812 1.55859L6.53125 9.80859C6.21875 10.1211 5.75 10.1211 5.46875 9.80859L1.21875 5.55859C0.90625 5.27734 0.90625 4.80859 1.21875 4.52734C1.5 4.21484 1.96875 4.21484 2.25 4.52734L5.96875 8.24609L13.7188 0.496094C14 0.214844 14.4688 0.214844 14.75 0.496094H14.7812Z",
		fill: "currentColor",
		stroke: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgIconCheck);
export { ForwardRef as ReactComponent };
